import { EntityBadge, EntityBadgeProps } from "src/components/badges/entity";

/**
 * The properties for {@link GroupBadge}
 */
export type GroupBadgeProps = Omit<EntityBadgeProps, "entity" | "prefix" | "href" | "params"> & {
    /**
     * The group this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    group: { uuid: string; name: string; description?: string };
};

/**
 * A badge labeled `group:name` linking to the group's page
 */
export function GroupBadge(props: GroupBadgeProps) {
    const { group, ...rest } = props;

    return (
        <EntityBadge
            {...rest}
            entity={group}
            prefix={"group"}
            href={"/a/groups/$groupId/general"}
            params={{ groupId: group.uuid }}
        />
    );
}
